import React from 'react';
import TAGScreeningRenderer from './TAGScreeningRenderer';
import CustomMarkdownRenderer from './CustomMarkdownRenderer';

const HybridTAGRenderer = ({ evaluationResult }) => {
  // Parse the result if it's a string
  let parsedResult;
  try {
    parsedResult = typeof evaluationResult === 'string' 
      ? JSON.parse(evaluationResult) 
      : evaluationResult;
  } catch (error) {
    // If parsing fails, treat as plain markdown
    console.warn("Failed to parse evaluation result as JSON", error);
    return <CustomMarkdownRenderer markdownContent={evaluationResult} />;
  }
  
  // Check if we have the hybrid format (both markdown and structured data)
  if (parsedResult && (parsedResult.markdown || parsedResult.structured)) {
    // If we have structured data, use the structured renderer
    if (parsedResult.structured) {
      // Log the number of questions to verify
      if (parsedResult.structured.technicalQuestions) {
        console.log(`Rendering ${parsedResult.structured.technicalQuestions.length} technical questions`);
      }
      if (parsedResult.structured.behavioralQuestions) {
        console.log(`Rendering ${parsedResult.structured.behavioralQuestions.length} behavioral questions`);
      }
      
      return <TAGScreeningRenderer evaluationData={parsedResult.structured} />;
    }
    
    // Otherwise fall back to markdown
    return <CustomMarkdownRenderer markdownContent={parsedResult.markdown} />;
  }
  
  // Legacy support for plain markdown string
  return <CustomMarkdownRenderer markdownContent={evaluationResult} />;
};

export default HybridTAGRenderer;